import React from 'react';

import Popup from '../../Popup';
import styles from './eventDuplicatePopup.scss';

const EventDuplicatePopup = (props) => {
    const { onCtaClick } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.eventDuplicatePopup}`}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            <div className="popup-section p24 pt0 pb0">
                <h5 className={`${styles.title}`}>Your Event Has Been Duplicated</h5>
            </div>
            <div className={`${styles.section}`}>
                <div className={`${styles.subSection}`}>
                    <span className={`${styles.textOrange}`}>Please note:&nbsp;</span>
                    All details, including your <span className={`${styles.textBlack}`}>event and division dates</span>,
                    have been carried over to the new event. Please make sure to <span className={`${styles.textBlack}`}>review and/ or edit&nbsp;</span>
                    these dates for your new event before publishing.
                </div>
            </div>
            <div className="d-flex aic jcc mt20 mb16">
                <button
                    className={'btn btn-primary text-uppercase'}
                    type="button"
                    onClick={onCtaClick}
                >
                    Got it
                </button>
            </div>
        </Popup>
    );
};

export default EventDuplicatePopup;
